import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api";
import { youtubeEmbed } from "@/lib/constants";
import Reveal from "@/components/Reveal";
import { Loader2, PlayCircle } from "lucide-react";

export default function VideosPage() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        apiClient
            .get("/videos")
            .then((r) => setItems(r.data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="videos-page" className="container-padded section-spacing">
            <div className="max-w-3xl">
                <div className="overline mb-4">Video Portfolio</div>
                <h1 className="font-serif text-5xl md:text-6xl text-ink leading-[1.05]">See the work in motion.</h1>
                <p className="text-stone-muted mt-5 text-lg">Process films, walkthroughs and before-and-after restoration stories from inside our workshop.</p>
            </div>

            {loading ? (
                <div className="py-20 flex justify-center text-walnut mt-12"><Loader2 className="animate-spin" /></div>
            ) : items.length === 0 ? (
                <div className="py-20 text-center text-stone-muted mt-12">No videos yet — check back soon.</div>
            ) : (
                <div className="grid md:grid-cols-2 gap-10 md:gap-14 mt-14">
                    {items.map((v, i) => (
                        <Reveal key={v.id} delay={(i % 4) * 100}>
                            <div data-testid={`video-item-${v.id}`} className="group">
                                <div className="aspect-video bg-sand overflow-hidden relative">
                                    <iframe
                                        src={youtubeEmbed(v.youtube_url)}
                                        title={v.title}
                                        className="w-full h-full"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    />
                                </div>
                                <div className="mt-5 flex items-start gap-3">
                                    <PlayCircle size={22} className="text-walnut shrink-0 mt-1" />
                                    <div>
                                        <div className="font-serif text-2xl text-ink">{v.title}</div>
                                        {v.description && <p className="text-sm text-stone-muted mt-2 leading-relaxed">{v.description}</p>}
                                    </div>
                                </div>

                                {(v.before_image || v.after_image) && (
                                    <div className="mt-6 grid grid-cols-2 gap-3">
                                        {v.before_image && (
                                            <figure>
                                                <img src={v.before_image} alt="Before" className="w-full aspect-[4/3] object-cover" />
                                                <figcaption className="text-[11px] uppercase tracking-widest text-walnut-light mt-2">Before</figcaption>
                                            </figure>
                                        )}
                                        {v.after_image && (
                                            <figure>
                                                <img src={v.after_image} alt="After" className="w-full aspect-[4/3] object-cover" />
                                                <figcaption className="text-[11px] uppercase tracking-widest text-walnut-light mt-2">After</figcaption>
                                            </figure>
                                        )}
                                    </div>
                                )}
                            </div>
                        </Reveal>
                    ))}
                </div>
            )}
        </div>
    );
}
